import React from 'react';
import ProjectItem from "./ProjectItem/ProjectItem";
import './ProjectsFiles.scss';

const ProjectsFiles = ({projects, activeProjects, token, setSubscriptionCancel}) => {
    return (
        <div className="product-files">
            <div className="product-files--files">
                <h2>FILES</h2>
                <div className="files-item">
                    {projects && projects.data && projects.data.map((project) => (
                            <ProjectItem key={project.id} project={project} activeProjects={activeProjects} token={token} setSubscriptionCancel={setSubscriptionCancel}
                            />
                        ))}
                </div>
            </div>
        </div>
    );
}

export default ProjectsFiles;
